import api from '../api';

/**
 * Update a table with the given tableCode and updatedTable data.
 *
 * @param {string} tableCode - The code identifying the table to be updated.
 * @param {Object} updatedTable - The new data for the table.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const updateTable = async (tableCode, updatedTable) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/table/update`;

  try {
    const response = await api.post(endpoint, {
      table_code: tableCode,
      table: updatedTable,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating table:', error);
    throw error;
  }
}

export default updateTable;
